import { Link } from "react-router-dom";
import { scrollToId } from "../lib/api";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-primary text-primary-foreground py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-serif text-3xl md:text-4xl tracking-tight">
              The Timeshare <em className="text-accent">Edit</em>
            </p>
            <p className="mt-6 text-primary-foreground/60 max-w-sm text-sm leading-relaxed">
              Independent education for vacation ownership owners — buying more, selling well,
              and choosing companies you can trust.
            </p>
            <p className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-accent" data-testid="footer-app-badge">
              Companion app — coming soon
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-primary-foreground/40">Explore</p>
            <ul className="mt-5 space-y-3 text-sm font-semibold">
              {[["The Chapters", "guides"], ["Red Flag Friday", "scamwatch"], ["Decision Tool", "decision-tool"], ["Calculator", "calculator"], ["Companies", "companies"], ["Our Independence", "independence"], ["Reviews", "reviews"], ["Letter Templates", "templates"], ["Pricing", "pricing"], ["Mobile App", "app"], ["Refer & Reward", "refer"], ["Consultation", "consult"]].map(([label, id]) => (
                <li key={id}>
                  <button
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollToId(id)}
                    className="text-primary-foreground/70 hover:text-accent transition-colors duration-300"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-primary-foreground/40">The small print</p>
            <p className="mt-5 text-xs text-primary-foreground/50 leading-relaxed" data-testid="footer-disclaimer">
              The Timeshare Edit is an independent educational resource. Nothing on this site constitutes financial,
              legal or tax advice, and company profiles are illustrative composites, not endorsements. We accept no
              referral fees, commissions or compensation from any company — our only obligation is to owners.
              Always consult a qualified professional and verify any company independently before signing a contract
              or sending money.
            </p>
            <Link to="/admin/login" data-testid="footer-admin-link" className="inline-block mt-6 text-xs font-semibold text-primary-foreground/40 hover:text-accent transition-colors duration-300">
              Admin sign in
            </Link>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-primary-foreground/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-primary-foreground/40">
          <p>© {new Date().getFullYear()} The Timeshare Edit. All rights reserved.</p>
          <p>Built for owners, by people who read the contracts.</p>
        </div>
      </div>
    </footer>
  );
}
